
import update from 'react-addons-update';

var iState = {
    Setting: {},
}

const UpdateConfiguration = (state = iState, action) => {
    switch (action.type) {

        case 'UpdateSystemSetting':
            return update(state, {
                Setting: { $set: action.payload.data },
            });

        default:
            return state;

    }

}

export default UpdateConfiguration;